import { store } from '../..'
import { ServiceProvider } from '../../services/api.types'
import { setIntegration, finalizeGarminIntegration } from '../integration/integrationActions'
import { ROUTES } from '../Routes/routePaths'
import { getFormattedUrl } from './integrationUrl'
import { push } from 'connected-react-router'
import { currentLang, currentLangString } from '../../i18nInit'
import { doAppleSignInFail } from '../../components/YumAppleSignIn/store/AppleSignInActions'
import { doGoogleSignIn } from '../../components/YumGoogleSignIn/store/GoogleSignInActions'
import { getGoogleSignInRedirectUri } from '../../components/YumGoogleSignIn/YumGoogleSignIn'
import ApiClient from '../../services/ApiClient'
import apiUrl from '../../services/apiUrl'
import { getWhoAmI } from '../auth/authActions'
import { isNative } from './isNative'
import { App } from '@capacitor/app'
import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { Preferences } from '@capacitor/preferences'

const IWindow = window as unknown as IWindow

export const redirectUrl = () => ROUTES.CLIENT_ACTIVITY.to

export const openUrl = async (url: string, openBlank?: boolean) => {
  const target = openBlank ? '_blank' : '_self'
  if (!isNative()) {
    IWindow.open(url, target, '')
    return
  }

  await Browser.open({
    url,
    toolbarColor: Capacitor.getPlatform() === 'android' ? '#006fff' : undefined,
    presentationStyle: openBlank ? 'popover' : 'fullscreen',
  })
}

export const openPrivacyPolicy = () => {
  const url = currentLangString === 'et' ? `https://yumuuv.com/et/privacy-policy` : `https://yumuuv.com/privacy-notice`
  openUrl(url, true)
}

export const openTermsOfService = () => {
  const url =
    currentLangString === 'et'
      ? `https://yumuuv.com/et/terms-and-conditions`
      : `https://yumuuv.com/terms-and-conditions`
  openUrl(url, true)
}

export const openPricing = () => {
  const url = currentLangString === 'et' ? 'https://yumuuv.com/et/hinnastus' : 'https://yumuuv.com/pricing'
  openUrl(url, true)
}

export const openActivityIndexArticle = () => {
  let url = `https://yumuuv.com/blog/physical-activity-level-calculator`
  if (currentLangString === 'et') {
    url = `https://yumuuv.com/et/blogi/aktiivsusindeks`
  }
  openUrl(url, true)
}

const handleOpenURL = async (url: string) => {
  console.log('handleOpenURL', url)

  // WITHOUT APPLINKS:                     yumuuv://settings?code=4/0AbUR2VMIa4--76axICO3iFLhc4pEsjqIBt4jVaEU4ljTyVCGhIITT1hQdFqxtBxDv-RZEg&scope=https://www.googleapis.com/auth/fitness.activity.read%20https://www.googleapis.com/auth/fitness.location.read
  // WITH APPLINKS: https://app.yumuuv.com/integration-proxy?code=4/0AbUR2VNw3sABRIEagXGNyDamBwW3AW41sCyOj44HVqRlRd5uPZlHJFs2C3BQTtmJ3Hl0Jg&scope=https://www.googleapis.com/auth/fitness.activity.read%20https://www.googleapis.com/auth/fitness.location.read

  if (Capacitor.getPlatform() === 'ios') await Browser.close()

  const { authorizationCode, serviceProvider, oauthToken, oauthVerifierValue } = await getFormattedUrl(url)

  // Remove "yumuuv://" or "https://app.yumuuv.com/".
  let cleanedUrl = url

  if (cleanedUrl.startsWith('yumuuv://')) {
    cleanedUrl = cleanedUrl.substring(9)
  }

  if (cleanedUrl.startsWith('https://app.yumuuv.com/')) {
    cleanedUrl = cleanedUrl.substring(23)
  }

  if (cleanedUrl.startsWith('app-proxy/') || cleanedUrl.startsWith('web-proxy/')) {
    cleanedUrl = cleanedUrl.substring(10)
  }

  const urlParts = cleanedUrl.split('?')
  const pathname = urlParts[0]
  const query = urlParts[1]

  console.log('pathname: ' + pathname)
  console.log('query: ' + query)
  if (['settings', 'integration-proxy'].includes(pathname) && query) {
    console.log('Activity data logic')
    const redirectUrl = `https://app.yumuuv.com${ROUTES.INTEGRATION_PROXY.to}`

    // Finish integration for GARMIN.
    if (serviceProvider === ServiceProvider.GARMIN && oauthToken && oauthVerifierValue) {
      store.dispatch(
        finalizeGarminIntegration({
          redirectUrl,
          oauthToken,
          oauthVerifierValue,
        }),
      )
    }
    // Finish integration for GOOGLE_FIT, FITBIT and POLAR.
    else if (authorizationCode) {
      store.dispatch(
        setIntegration({
          authorizationCode,
          serviceProvider,
          redirectUrl,
          redirect: true,
        }),
      )
    }
  } else if (query && (pathname === 'login' || pathname === 'signup')) {
    const queryParams = new URLSearchParams(query)
    const signInWithAppleMsg = queryParams.get('signInWithApple') || ''
    if (signInWithAppleMsg) {
      console.log('Apple signup logic')
      if (signInWithAppleMsg === 'success') {
        document.body.classList.add('logging-in')
        const sessionId = queryParams.get('sessionId') || ''

        /*if (isNative()) {
          const sessionToken = window.btoa(sessionId)
          await Preferences.set({ key: 'sessionToken', value: sessionToken })
        } else {*/
        console.log('Trying to get session: ' + sessionId)
        await ApiClient.post(apiUrl('/auth/login'), { sessionId: String(sessionId) })
        //}

        store.dispatch(getWhoAmI())
      } else {
        store.dispatch(
          doAppleSignInFail({
            signInWithAppleMsg,
          }),
        )
      }
    } else {
      console.log('Google signup logic')
      const redirectUri = getGoogleSignInRedirectUri()
      const { value: nonce } = await Preferences.get({ key: 'googleSignInNonce' })
      const { value: signUpCode } = await Preferences.get({ key: 'googleSignUpCode' })
      store.dispatch(
        doGoogleSignIn({
          authorizationCode,
          redirectUri,
          nonce: nonce || '',
          lang: currentLang,
          redirectTo: `/${pathname}`,
          signUpCode: signUpCode || '',
        }),
      )
    }
  } else {
    store.dispatch(push(`/${pathname}`))
  }

  // Clean up.
  await Preferences.remove({ key: 'isIntegrationHost' })
}

App.addListener('appUrlOpen', async (data) => {
  console.log('appUrlOpen:', data)
  if (data.url) await handleOpenURL(data.url)
})
